import { createApp } from 'vue'
import App from './App.vue'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

const app = createApp(App)

import router from './router'

app.use(router)
app.use(ElementPlus)
app.mount('#app')

document.documentElement.classList.add('dark')